import { Component } from '@angular/core';
import { FireAlarmComponentDto } from '@authority-labs/api-interfaces';
import { FireAlarmComponentsService } from '../fire-alarm-components.service';

@Component({
  selector: 'authority-labs-select-fire-alarm-component-dialog',
  templateUrl: './select-fire-alarm-component-dialog.component.html',
  styleUrls: ['./select-fire-alarm-component-dialog.component.scss']
})
export class SelectFireAlarmComponentDialogComponent {
  title = 'רכיב';
  searchFields = ['type', 'model', 'manufacture'];

  getLabel(component: FireAlarmComponentDto): string {
    return component ? component.name : '';
  }

  constructor(public service: FireAlarmComponentsService) {}
}
